import { enableProdMode, StaticProvider } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { downgradeComponent, downgradeModule } from '@angular/upgrade/static';

import { HostHybridComponent } from './app/host-hybrid/host-hybrid.component';
import { HostModule } from './app/host.module';
import { environment } from './environments/environment';

export function bootstrapAngular(extra: StaticProvider[]): any {
    if (environment.production) {
        enableProdMode();
    }

    return platformBrowserDynamic(extra)
        .bootstrapModule(HostModule)
        .catch((err) => console.log(err));
}

const angular = window['angular'];

const downgraded = angular
    .module('downgraded', [downgradeModule(bootstrapAngular)])
    .directive('hostHybridRoot', downgradeComponent({ component: HostHybridComponent, propagateDigest: false }));

angular.module('estensaWebHtml5').config([
    '$stateProvider',
    ($stateProvider) => {
        $stateProvider
            .state('new', {
                url: '/*new',
                params: {
                    ignoreRouteChangeEvent: true,
                },
                template: '',
            })
            .state('report.cardioVisit', {
                url: '/new/vnext/cardio-visit/worklist',
                data: { mainStateCode: 'REPORTLISTVS' },
                params: {},
            })
            .state('specialty.worklist', {
                url: '/new/vnext/specialty-reporting/worklist',
                params: {},
            })
            .state('report.ecgWorklist', {
                url: '/new/vnext/ecg/worklist',
                data: { mainStateCode: 'REPORTLISTECG' },
                params: {},
            })
            .state('vna', {
                abstract: true,
                data: { mainStateCode: 'SEVNADASHBOARD' },
                template: '',
            })
            .state('vna.mainSearch', {
                params: {},
                url: '/new/vna/search',
            })
            .state('mps', {
                abstract: true,
                data: { mainStateCode: 'SEMPSDASHBOARD' },
                template: '',
            })
            .state('mps.completedCd', {
                url: '/new/vnext/mps/completedcd',
                data: { mainStateCode: 'WORKLISTCOMPLETEDCD' },
                params: {},
            })
            .state('mps.onPrintingCd', {
                url: '/new/vnext/mps/onprintingcd',
                data: { mainStateCode: 'WORKLISTONPRINTINGCD' },
                params: {},
            })
            .state('collaboration.teams', {
                url: '/new/vnext/collaboration/teams',
                data: { mainStateCode: 'COLLABORATIONTEAMS' },
                params: {},
            })
            .state('tool.upload', {
                url: '/new/vnext/tool/upload',
                data: { mainStateCode: 'TOOLUPLOAD' },
                params: {},
            })
            .state('tool.upload-dicom', {
                url: '/new/vnext/tool/upload-dicom',
                data: { mainStateCode: 'TOOLUPLOAD' },
                params: {},
            })
            .state('telemonitoring', {
                abstract: true,
                data: { mainStateCode: 'SETELEMONITORINGDASHBOARD' },
                template: '',
            })
            .state('telemonitoring.worklist', {
                url: '/new/vnext/telemonitoring/worklist',
                data: { mainStateCode: 'TELEMONITORINGWORKLIST' },
                params: {},
            })
            .state('telemonitoring.alarms', {
                url: '/new/vnext/telemonitoring/alarms',
                params: {},
            })
            .state('telemonitoring.chat', {
                url: '/new/vnext/telemonitoring/chat',
                params: {},
            })
            .state('telemonitoring.training', {
                url: '/new/vnext/telemonitoring/training',
                params: {},
            })
            .state('thirdpart.waiting', {
                url: '/new/vnext/third-part-waiting',
                params: {},
            })
            .state('nresearch', {
                url: '/new/vnext/nre/search',
                data: { mainStateCode: 'NREREGISTERPAGECARDIO' },
                params: {},
            })
            .state('teleconsultation.vnext', {
                abstract: true,
            })
            .state('teleconsultation.vnext.new', {
                url: '/new/vnext/teleconsultation/create/:idPatient',
                params: {
                    skipFromComeBackFlow: true,
                },
            })
            .state('teleconsultation.vnext.new.external', {
                url: '/new/vnext/teleconsultation/create/',
                params: {
                    skipFromComeBackFlow: true,
                },
            })
            .state('teleconsultation.vnext.edit', {
                url: '/new/vnext/teleconsultation/edit/:examinationId',
                params: {},
            })
            .state('administrative_dummyVNext2', {
                url: '/new/vnext/administrative/dummyVNext2',
                data: { mainStateCode: 'DUMMYVNEXT2' },
                params: {},
            })
            .state('administrative_execution', {
                url: '/new/vnext/administrative/execution',
                data: { mainStateCode: 'EXECUTIONVNEXT' },
                params: {},
            })
            .state('report.specialityWorklist', {
                url: '/new/vnext/specialty-reporting/worklist',
                data: { mainStateCode: 'REPORTLISTSPECIALTY' },
                params: {},
            });
    },
]);

angular.module('estensaWebHtml5').run([
    '$rootScope',
    ($rootScope) => {
        $rootScope.$on('$stateChangeStart', (_, toState) => {
            $rootScope.uiRouterDeactivated = toState.url.match(/^\/\*?new/);
        });
    },
]);

angular.bootstrap(document.body, [downgraded.name, 'estensaWebHtml5', 'pascalprecht.translate']);
